'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodashCompat = require('lodash-compat');

var _lodashCompat2 = _interopRequireDefault(_lodashCompat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

var ApiError = window.__mtf_utils_ApiError;
var ApiStatusError = window.__mtf_utils_ApiStatusError;

var _apiError = ApiError && new ApiError({});

//FIXME 要求数据形式{ data, status }，与regularApi关联度太强

/**
 * fetch 请求
 * @param url 请求的url
 * @param params 请求的参数
 * @param options 请求的其他配置参数
 */
function ajax(url, params, options) {
  return new Promise(function ($return, $error) {
    var $Try_1_Catch = function (e) {
      e.__proto__ = _apiError;
      return $error(e);
    }.$asyncbind(this, $error);

    function $Try_1_Post() {
      if (res.status == 1) {
        return $return(res.data);
      } else {
        if (ApiStatusError) {
          return $error(new ApiStatusError(res.data));
        } else {
          //FIXME 报错信息
          return $error(new Error(res.message));
        }
      }
      return $return();
    }

    var _options = _lodashCompat2.default.assign({
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin'
    }, options);
    try {
      _options.body = JSON.stringify(params);
    } catch (e) {
      console.error('JSON stringify error', params);
    }

    var res = void 0;
    try {
      return Promise.resolve(fetch(url, _options)).then(function ($await_2) {
        res = $await_2;
        return Promise.resolve(res.json()).then(function ($await_3) {
          res = $await_3;
          $Try_1_Post.call(this)
        }.$asyncbind(this, $Try_1_Catch), $Try_1_Catch);
      }.$asyncbind(this, $Try_1_Catch), $Try_1_Catch);
    } catch (e) {
      $Try_1_Catch(e)
    }
  }.$asyncbind(this));
}

exports.default = ajax;